import { IActivationCase } from "@/models/IActivationCase";

import { BaseRepository } from "@/repositories/BaseRepository";

class ActivationCaseRepository extends BaseRepository<IActivationCase> {
    constructor() {
        super("/activationcases");
    }
}

const activationcaseRepository = new ActivationCaseRepository();

export { ActivationCaseRepository, activationcaseRepository };
